/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'automation-menu.empty-state.image.alt': 'Icono de lista de automatización vacía',
  'automation-menu.empty-state.learn-more.link': 'Más información sobre el desencadenador manual',
  'automation-menu.modal.empty.automations.admin.description':
    'Usa el desencadenador manual para rellenar un menú de selecciones que todo el mundo o las personas que tú especifiques puedan aplicar como automatizaciones en un clic.',
  'automation-menu.modal.empty.automations.user.description':
    'Los administradores aún no han configurado ninguna automatización con desencadenador manual.',
  'automation-menu.modal.error.description':
    'Esta acción está tardando un poco en cargar. Prueba a actualizar la página.',
  'automation-menu.modal.error.image.alt': 'Icono de error',
  'automation-menu.modal.footer.automate-button': 'Automatizar',
  'automation-menu.modal.footer.cancel-button': 'Cancelar',
  'automation-menu.modal.footer.get-started-button': 'Crear automatización',
  'automation-menu.modal.footer.ok-button': 'Aceptar',
  'automation-menu.modal.header.icon.label': 'Icono del encabezado del modal de automatización',
  'automation-menu.success-state.message': 'Tu automatización está en progreso',
  'fabric.linking.access_exists_description': 'Solicita acceso para ver este contenido desde {hostname}.',
  'fabric.linking.actions': 'Acciones',
  'fabric.linking.add_account': 'Añadir cuenta',
  'fabric.linking.ai_summarize': 'Resumir',
  'fabric.linking.ai_summarized': 'Resumido por Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Resumido por AI',
  'fabric.linking.ai_summarized_info': 'La calidad de la información puede variar. <a>Más información</a>',
  'fabric.linking.ai_summarized_info_short': 'La calidad del contenido puede variar',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence está trabajando en...',
  'fabric.linking.ai_summary_action': 'Resumir con AI',
  'fabric.linking.ai_summary_action_description': 'Resume el contenido de este enlace con Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'No podemos mostrar los resultados de este resumen porque va en contra de la <a>política de uso aceptable de Atlassian</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence no puede generar un resumen ahora mismo porque hay demasiado contenido que resumir.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) no responde. Inténtalo de nuevo más tarde o <a>consulta el estado de AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence no ha podido procesar la solicitud porque tu contenido incluye enlaces a contenido restringido por la HIPAA.',
  'fabric.linking.assigned_to': 'Asignado a {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Aplica una automatización a <b>{name}</b>.{br}Las selecciones disponibles están controladas por Confluence y los administradores del espacio.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automatizaciones de páginas',
  'fabric.linking.automation-action.icon.label': 'Icono de automatización',
  'fabric.linking.automation-action.title': 'Ver reglas de automatización',
  'fabric.linking.automation-action.tooltip': 'Selecciona una regla de automatización que ejecutar',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Cancelar',
  'fabric.linking.cannot_connect': 'No se podido establecer la conexión. Inténtalo de nuevo',
  'fabric.linking.cannot_find_link': 'No se ha podido encontrar el enlace',
  'fabric.linking.check_this_link': 'Comprobar este enlace',
  'fabric.linking.click_to_join': 'Únete a {context}',
  'fabric.linking.click_to_join_description': 'Se te ha aprobado, por lo que puedes unirte a {context} de inmediato.',
  'fabric.linking.close': 'Cerrar',
  'fabric.linking.connect_account_description': 'Abriremos otra página para ayudarte a conectar tu cuenta de {name}',
  'fabric.linking.connect_link_account': 'Conectar para obtener vista previa',
  'fabric.linking.connect_link_account_card_view': 'Conectar',
  'fabric.linking.connect_link_account_card_view_description':
    'Para mostrar una vista previa de este enlace, conecta tu cuenta de {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Conecta tu cuenta de {context}',
  'fabric.linking.connect_to': 'Conectarse a {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Conectarse a {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Conecta tu cuenta de {context} para colaborar en el trabajo a través de los productos de Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Conecta tu cuenta para colaborar en el trabajo a través de los productos de Atlassian.',
  'fabric.linking.continue': 'Continuar',
  'fabric.linking.copied_summary_action_description': 'Resumen copiado al portapapeles',
  'fabric.linking.copied_url_to_clipboard': '¡Copiada!',
  'fabric.linking.copy_summary_action': 'Copiar resumen',
  'fabric.linking.copy_summary_action_description': 'Copiar resumen',
  'fabric.linking.copy_url_to_clipboard': 'Copiar enlace',
  'fabric.linking.couldnt_load_link': 'Por algún motivo que desconocemos, no hemos podido cargar este enlace.',
  'fabric.linking.create_on_absolute': 'Creación: {context}',
  'fabric.linking.create_on_relative': 'Fecha de creación: {context}',
  'fabric.linking.created_by': 'Creado por {context}',
  'fabric.linking.delete': 'Eliminar',
  'fabric.linking.direct_access': 'Unirme ahora',
  'fabric.linking.direct_access_description':
    'Tu equipo utiliza {product} para colaborar y tú puedes empezar a hacerlo ahora mismo.',
  'fabric.linking.direct_access_title': 'Únete a {product} para ver este contenido',
  'fabric.linking.download': 'Descargar',
  'fabric.linking.download_description': 'Descarga este archivo en tu almacenamiento local',
  'fabric.linking.download_file': 'Descargar archivo',
  'fabric.linking.edit': 'Editar',
  'fabric.linking.follow': 'Seguir',
  'fabric.linking.follow_goal': 'Seguir meta',
  'fabric.linking.follow_goal_description': 'Sigue esta meta para recibir notificaciones de las actualizaciones',
  'fabric.linking.follow_goal_error':
    'Se ha producido un error al intentar seguir la meta. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.follow_project': 'Seguir proyecto',
  'fabric.linking.follow_project-galaxia': 'Seguir espacio',
  'fabric.linking.follow_project_description': 'Sigue para recibir notificaciones de este proyecto',
  'fabric.linking.follow_project_description-galaxia': 'Sigue para recibir notificaciones de este espacio',
  'fabric.linking.follow_project_error':
    'Se ha producido un error al intentar seguir el proyecto. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.follow_project_error-galaxia':
    'Se ha producido un error al intentar seguir el espacio. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.forbidden_access': 'Tienes prohibido el acceso',
  'fabric.linking.forbidden_description': 'Ponte en contacto con el administrador para solicitar acceso a {hostname}.',
  'fabric.linking.forbidden_title': 'No tienes acceso a este contenido',
  'fabric.linking.generic_error_message': 'Se ha producido un error',
  'fabric.linking.go_back': 'Volver',
  'fabric.linking.invalid_permissions': 'Contenido restringido',
  'fabric.linking.invalid_permissions_description':
    'Deberás solicitar el acceso o probar con otra cuenta para obtener esta vista previa.',
  'fabric.linking.join_to_view': 'Únete a {context} para ver esta incidencia',
  'fabric.linking.join_to_view-issue-term-refresh': 'Únete a {context} para ver esta actividad',
  'fabric.linking.learn_more_about_connecting_account':
    'Obtén más información sobre cómo conectar tu cuenta a los productos de Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'Más información sobre los enlaces inteligentes.',
  'fabric.linking.link_safety_warning_message':
    'El enlace {unsafeLinkText} te redirige a un sitio diferente, <a>actual link here</a>.',
  'fabric.linking.loading': 'Cargando…',
  'fabric.linking.modified_on_absolute': 'Fecha de actualización: {context}',
  'fabric.linking.modified_on_relative': 'Fecha de actualización: {context}',
  'fabric.linking.more_actions': 'Más acciones',
  'fabric.linking.no_access_title': 'Únete a {product} para ver este contenido',
  'fabric.linking.not_found_description': 'La página no existe o puede haberse cambiado después de añadir este enlace.',
  'fabric.linking.not_found_title': 'No podemos mostrarte esta página de {product}',
  'fabric.linking.open_issue_in_jira': 'Abrir incidencia en Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Abrir actividad en Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Abrir enlace en una nueva pestaña',
  'fabric.linking.owned_by': 'Propiedad de {context}',
  'fabric.linking.owned_by_override': 'De {context}',
  'fabric.linking.pending_request': 'Tu solicitud de acceso está pendiente',
  'fabric.linking.preview_close': 'Cerrar vista previa',
  'fabric.linking.preview_description': 'Abre una vista previa a pantalla completa de este enlace',
  'fabric.linking.preview_improved': 'Abrir vista previa',
  'fabric.linking.preview_max_size': 'Ver a pantalla completa',
  'fabric.linking.preview_min_size': 'Cerrar pantalla completa',
  'fabric.linking.preview_modal': 'Abrir modal de vista previa',
  'fabric.linking.preview_panel': 'Abrir panel de vista previa',
  'fabric.linking.priority_blocker': 'Impedimento',
  'fabric.linking.priority_critical': 'Crítica',
  'fabric.linking.priority_high': 'Alta',
  'fabric.linking.priority_highest': 'Más alta',
  'fabric.linking.priority_low': 'Baja',
  'fabric.linking.priority_lowest': 'Más baja',
  'fabric.linking.priority_major': 'Importante',
  'fabric.linking.priority_medium': 'Media',
  'fabric.linking.priority_minor': 'No importante',
  'fabric.linking.priority_trivial': 'Trivial',
  'fabric.linking.priority_undefined': 'Sin definir',
  'fabric.linking.read_time': '{context} min de lectura',
  'fabric.linking.related': 'Relacionado',
  'fabric.linking.related_links_found_in': 'Encontrado en',
  'fabric.linking.related_links_includes_links_to': 'Incluye enlaces a',
  'fabric.linking.related_links_modal_error_description':
    'Comprueba tu conexión o actualiza la página para volver a intentarlo',
  'fabric.linking.related_links_modal_error_title': 'Tenemos problemas para cargar los enlaces relacionados',
  'fabric.linking.related_links_modal_title': 'Enlaces relacionados',
  'fabric.linking.related_links_modal_unavailable_description':
    'Revisamos y añadimos continuamente enlaces relacionados de las páginas actualizadas u otros tipos de contenido',
  'fabric.linking.related_links_modal_unavailable_title': 'Ningún enlace relacionado encontrado',
  'fabric.linking.related_links_not_found': 'No hemos encontrado ningún enlace que mostrar aquí.',
  'fabric.linking.related_links_view_related_links': 'Ver enlaces relacionados',
  'fabric.linking.related_links_view_related_urls': 'Consultar enlaces recientes',
  'fabric.linking.request_access': 'Solicitar acceso',
  'fabric.linking.request_access_description':
    'Tu equipo utiliza {product} para colaborar. Envía al administrador una solicitud para poder acceder.',
  'fabric.linking.request_access_pending': 'Aprobación pendiente',
  'fabric.linking.request_access_pending_description':
    'Tu solicitud para acceder a {hostname} está pendiente de la aprobación del administrador.',
  'fabric.linking.request_access_pending_title': 'El acceso a {product} está pendiente',
  'fabric.linking.request_access_to_view': 'Solicita acceso a {context} para ver esta incidencia',
  'fabric.linking.request_access_to_view-issue-term-refresh': 'Solicita acceso a {context} para ver esta actividad',
  'fabric.linking.request_denied': 'Se ha denegado tu solicitud de acceso',
  'fabric.linking.request_denied_description':
    'El administrador no ha aprobado tu solicitud para ver las páginas de {product} de {hostname}.',
  'fabric.linking.restricted_link': 'Enlace restringido, prueba con otra cuenta',
  'fabric.linking.retry': 'Reintentar',
  'fabric.linking.save': 'Guardar',
  'fabric.linking.sent_on_absolute': 'Enviado el {context}',
  'fabric.linking.sent_on_relative': 'Enviado {context}',
  'fabric.linking.srclink': 'Ver en',
  'fabric.linking.srclinkunknown': 'Ver original',
  'fabric.linking.status_change_load_error': 'No hemos podido cargar los estados ni las transiciones',
  'fabric.linking.status_change_permission_error': 'No tienes permiso para realizar la transición de esta incidencia.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'No tienes permiso para realizar la transición de esta actividad.',
  'fabric.linking.status_change_update_error': 'No hemos podido actualizar el estado',
  'fabric.linking.team_members_count': '{context} miembros',
  'fabric.linking.try_again': 'Volver a intentarlo',
  'fabric.linking.try_another_account': 'Probar otra cuenta',
  'fabric.linking.unassigned': 'Sin asignar',
  'fabric.linking.unauthorised_account_description':
    'Estás intentando previsualizar un enlace a una página privada de {context}. Te recomendamos que revises la URL o contactes con el propietario de la página.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Estás intentando previsualizar un enlace a una página privada. Te recomendamos que revises la URL o contactes con el propietario de la página.',
  'fabric.linking.unauthorised_account_name': 'No podemos mostrar las páginas privadas de {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'No podemos mostrar páginas privadas',
  'fabric.linking.unfollow': 'Dejar de seguir',
  'fabric.linking.unfollow_goal': 'Dejar de seguir meta',
  'fabric.linking.unfollow_goal_description': 'Deja de seguir para no recibir más notificaciones de esta meta',
  'fabric.linking.unfollow_goal_error':
    'Se ha producido un error al intentar dejar de seguir la meta. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.unfollow_project': 'Dejar de seguir proyecto',
  'fabric.linking.unfollow_project-galaxia': 'Dejar de seguir espacio',
  'fabric.linking.unfollow_project_description': 'Deja de seguir para no recibir más notificaciones del proyecto',
  'fabric.linking.unfollow_project_description-galaxia':
    'Deja de seguir para no recibir más notificaciones del espacio',
  'fabric.linking.unfollow_project_error':
    'Se ha producido un error al intentar dejar de seguir el proyecto. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.unfollow_project_error-galaxia':
    'Se ha producido un error al intentar dejar de seguir el espacio. Comprueba tu conexión o actualiza la página y vuelve a intentarlo.',
  'fabric.linking.unlink_account': 'Desvincular cuenta',
  'fabric.linking.updated_by': 'Modificado por {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Ver',
};
